import { render, staticRenderFns } from "./PostingTypeList.vue?vue&type=template&id=e4305bd2"
import script from "./PostingTypeList.vue?vue&type=script&lang=js"
export * from "./PostingTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports